import React, { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { RoutePaths } from 'routes/paths'
import PaperWrapper from 'components/custom/PaperWrapper'
import ContentBodyWrapper from 'components/custom/ContentBodyWrapper'
import { componentPermissions } from 'config/permissions'
import { componentNames } from 'config/roles'
import ComingSoon from 'assets/images/coming-soon.svg'

const CompareAssemblies: FC = () => {
  const { t } = useTranslation()

  return (
    <ContentBodyWrapper title={t('toolbox.title')}>
      <PaperWrapper>
        <h1 className="text-center text-2xl font-bold mb-4">Coming Soon</h1>
        <div className="flex flex-col items-center gap-x-3 mb-4">
          <p className="mb-2">
            The sustamize Toolbox is currently in Alpha version undergoing
            customer testing and is not accessible to all users. Interaction
            with different resources on the toolbox might lead to 301 or 500
            server response.
          </p>
          <p className="mb-4">
            Please contact support@sustamizer.com in case of any questions, or
            if you want to take part in the testing.
          </p>
          <img
            src={ComingSoon}
            alt="coming-soon"
            className="w-1/4 self-center h-full mb-2"
          />
        </div>
      </PaperWrapper>
    </ContentBodyWrapper>
  )
}
const exportObj = {
  routeProps: {
    path: RoutePaths.toolboxAssemblerCompare,
    title: 'assembler.compare',
    element: <CompareAssemblies />,
    roles: componentPermissions[componentNames.pageAssembler],
    requiresAuthentication: true,
  },
  name: 'CompareAssemblies',
}

export default exportObj
